import React, { useState } from 'react';
import styleLabelInput from './LabelInput.module.scss';
import { Modal } from 'antd';
import Immagine from '../../components/Immagine/Immagine';

const LabelInput = props => {
  const [modalvisible, setModalVisible] = useState(false);

  function showModal() {
    setModalVisible(!modalvisible);
  }

  return (
    <>
      <span className={styleLabelInput.LabelInput}>
        {props.text}{' '}
        <Immagine
          urlImage={'petroil.svg'}
          name="info"
          clicked={() => showModal()}
        />
      </span>

      <Modal
        onCancel={showModal}
        open={modalvisible}
        closeIcon={<Immagine urlImage={'close-modal.svg'} name="close" />}>
        <>
          <h2>Finalità del trattamento</h2>
          {props.openPopUp === 'MKT' ? (
            <>
              <p>
                a) Invio di materiale pubblicitario, vendita diretta, indagini o
                ricerche di mercato e/o comunicazioni commerciali relative a
                prodotti e servizi propri di Prestipay e/o prodotti di Terzi;
              </p>
              <p>
                b) Promozione e vendita di prodotti e servizi propri di
                Prestipay e/o prodotti di Terzi mediante l’impiego di modalità
                automatizzate di contatto (ad esempio posta elettronica,
                telefax, SMS, MMS messaggistica istantanea, social network, app,
                sistemi automatizzati di chiamata senza l’intervento di un
                operatore, ecc.) e/o o modalità tradizionali (ad esempio
                telefonate con operatore e posta cartacea);
              </p>
              <p>
                c) Marketing diretto, promozione e vendita di prodotti e servizi
                propri di Prestipay e/o prodotti di Terzi mediante l’impiego dei
                risultati dell’attività di analisi e segmentazione qualora Lei
                abbia altresì rilasciato il consenso all’attività di
                profilazione;
              </p>
              {/* <p>d) Marketing diretto di prodotti di terzi mediante l’impiego dei risultati dell’attività di prevalutazione, qualora lei abbia altresì rilasciato il consenso per tale finalità.</p> */}
            </>
          ) : props.openPopUp === 'Terzi' ? (
            <>
              <p>
                Cessione dei Suoi dati personali ai soggetti terzi indicati
                nell’informativa per loro autonome finalità di marketing.
              </p>
            </>
          ) : props.openPopUp === 'Marketing' ? (
            <>
              <p>
                Elaborazione dei suoi dati personali, nonché abitudini di
                consumo, preferenze, interessi, comportamenti, con modalità
                automatizzate, al fine di individuare ed offrire servizi o
                attività più appropriate alla Sua persona.
              </p>
            </>
          ) : props.openPopUp === 'consentFourth' ? (
            <>
              <p>
                Cessione dei Suoi dati personali ai soggetti Terzi indicati
                nell’informativa per loro autonome finalità di prevalutazione
                per l’eventuale offerta di prodotti alternativi.
              </p>
            </>
          ) : null}
        </>
      </Modal>
    </>
  );
};

export default LabelInput;
